export default __webpack_public_path__ + "static/img4-117144831eedc6296e9d6cf734378e07.jpeg";